import { render, staticRenderFns } from "./AwardDuplication.vue?vue&type=template&id=508002dc&"
import script from "./AwardDuplication.vue?vue&type=script&lang=js&"
export * from "./AwardDuplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports